<template>
  <security-page>
    <template #left>
      <page-illustration :src="illustration" />
    </template>
    <template #right>
      <forgot-password-form />
    </template>
  </security-page>
</template>

<script>
import SecurityPage from "@/views/security/components/SecurityPage.vue";
import PageIllustration from "@/views/security/components/PageIllustration.vue";
import ForgotPasswordForm from "@/views/security/components/ForgotPasswordForm.vue";

export default {
  components: {
    SecurityPage,
    PageIllustration,
    ForgotPasswordForm,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      illustration: require("@/assets/images/illustrations/forgot-password.svg"),
    };
  },
};
</script>
